import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateCheckoutsMutationVariables = Types.Exact<{
  store_id: Types.Scalars['ID'];
  count: Types.Scalars['Int'];
}>;


export type CreateCheckoutsMutation = { __typename?: 'Mutation', createCheckouts: boolean };


export const CreateCheckoutsDocument = gql`
    mutation createCheckouts($store_id: ID!, $count: Int!) {
  createCheckouts(store_id: $store_id, count: $count)
}
    `;
export type CreateCheckoutsMutationFn = Apollo.MutationFunction<CreateCheckoutsMutation, CreateCheckoutsMutationVariables>;

/**
 * __useCreateCheckoutsMutation__
 *
 * To run a mutation, you first call `useCreateCheckoutsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCheckoutsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCheckoutsMutation, { data, loading, error }] = useCreateCheckoutsMutation({
 *   variables: {
 *      store_id: // value for 'store_id'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useCreateCheckoutsMutation(baseOptions?: Apollo.MutationHookOptions<CreateCheckoutsMutation, CreateCheckoutsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCheckoutsMutation, CreateCheckoutsMutationVariables>(CreateCheckoutsDocument, options);
      }
export type CreateCheckoutsMutationHookResult = ReturnType<typeof useCreateCheckoutsMutation>;
export type CreateCheckoutsMutationResult = Apollo.MutationResult<CreateCheckoutsMutation>;
export type CreateCheckoutsMutationOptions = Apollo.BaseMutationOptions<CreateCheckoutsMutation, CreateCheckoutsMutationVariables>;